import { render } from "./SettingsEmailsTemplates.vue?vue&type=template&id=ed66a2fa&scoped=true"
import script from "./SettingsEmailsTemplates.vue?vue&type=script&lang=js"
export * from "./SettingsEmailsTemplates.vue?vue&type=script&lang=js"

import "./SettingsEmailsTemplates.vue?vue&type=style&index=0&id=ed66a2fa&lang=scss"
import "./SettingsEmailsTemplates.vue?vue&type=style&index=1&id=ed66a2fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed66a2fa"]])

export default __exports__